import { firstLetterUppercase } from '@/utilities/firstLetterUppercase';
import { Switch, Tooltip } from '@material-ui/core';
import React from 'react';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HandshakeIcon from '@mui/icons-material/Handshake';
import RemoveIcon from '@mui/icons-material/Remove';

export const SEARCHABLE = ['user.email', 'user.username', 'business_name', 'user.user_id'];

export const TABS = [
    {
        header: 'Shippers',
        data: 'shippers',
    },
    {
        header: 'Carriers',
        data: 'carriers',
    },
    {
        header: 'Teammates',
        data: 'teammates',
    },
].map((tab, index) => ({ ...tab, index }));

export const COLUMNS = [
    {
        label: 'Tariff',
        value: (entity) => {
            const hasMarketplaceTariff = entity.pricing_overrides.some((po) => !po.oms && !po.partner_client_id);
            const hasPartnerTariff = entity.pricing_overrides.some((po) => !po.oms && !!po.partner_client_id);

            return (
                <>
                    {hasMarketplaceTariff && (
                        <Tooltip title="Carrier has one or more connected marketplace tariffs">
                            <CheckCircleIcon
                                css={css`
                                    color: ${colors.greens.primary};
                                    margin-right: ${hasPartnerTariff ? '4px' : '0'};
                                `}
                            />
                        </Tooltip>
                    )}
                    {hasPartnerTariff && (
                        <Tooltip title="Carrier has one or more partnership tariffs">
                            <HandshakeIcon
                                css={css`
                                    color: ${colors.oranges.primary};
                                `}
                            />
                        </Tooltip>
                    )}
                    {!hasMarketplaceTariff && !hasPartnerTariff && (
                        <Tooltip title="No tariffs attached to carrier">
                            <RemoveIcon />
                        </Tooltip>
                    )}
                </>
            );
        },
        tabs: ['Carriers'],
    },
    {
        label: 'Email',
        value: (entity) => entity.user.email,
    },
    {
        label: 'Username',
        value: (entity) => entity.user.username,
    },
    {
        label: 'Business',
        value: (entity) => entity.business_name,
        tabs: ['Shippers', 'Carriers'],
    },
    {
        label: 'Team Type',
        value: (entity) => firstLetterUppercase(entity.team_leader_type),
        tabs: ['Teammates'],
    },
    {
        label: 'UID',
        value: (entity) => entity.user.user_id,
    },
    {
        label: 'Airport Codes',
        value: (entity) => {
            const codes = entity.airportCodes;
            if (codes.length <= 3) {
                return codes.join(', ');
            }
            return `${codes.slice(0, 3).join(', ')}, ...and ${codes.length - 3} more`;
        },
        tabs: ['Carriers'],
    },
    {
        label: 'Status',
        value: (entity, loading, callbacks) => (
            <Switch
                color="primary"
                checked={entity.approved}
                onChange={() => callbacks.updateClient(entity.client_id, { approved: !entity.approved })}
                disabled={loading}
            />
        ),
        tabs: ['Shippers', 'Carriers'],
    },
    {
        label: 'Test Account',
        value: (entity, loading, callbacks) => (
            <Switch
                color="primary"
                checked={entity.test_acc}
                onChange={() => callbacks.updateClient(entity.client_id, { test_acc: !entity.test_acc })}
                disabled={loading}
            />
        ),
        tabs: ['Shippers', 'Carriers'],
    },
    {
        label: 'Partnerships Enabled',
        value: (entity, loading, callbacks) => (
            <Switch
                color="primary"
                checked={entity.partnerships_enabled}
                onChange={() =>
                    callbacks.updateClient(entity.client_id, { partnerships_enabled: !entity.partnerships_enabled })
                }
                disabled={loading}
            />
        ),
        tabs: ['Shippers', 'Carriers'],
    },
];
